import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((e: HttpErrorResponse) => {
      // Preserve the response body shape callers rely on (ApiErrorResponse), but
      // annotate it with the HTTP status so callers can distinguish a genuine 4xx
      // (e.g. 404) from a transient failure (429/5xx/network). Without the status a
      // throttled SSR request looked identical to a real not-found.
      const body = e.error;

      if (body !== null && typeof body === 'object' && !Array.isArray(body)) {
        return throwError(() => ({ ...body, status: e.status }));
      }

      return throwError(() => ({
        message: typeof body === 'string' ? body : e.message,
        status: e.status,
      }));
    }),
  );
};
